import type { Font } from '../types/font';

export const roboto: Font = {
  fontFamily: 'roboto-v32-m4b547q5',
  displayName: 'Roboto',
  sources: [
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillicExt',
      src: 'roboto-v32-cyrillic-ext-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'roboto-v32-cyrillic-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'greekExt',
      src: 'roboto-v32-greek-ext-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'roboto-v32-greek-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'roboto-v32-vietnamese-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'roboto-v32-latin-ext-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'roboto-v32-latin-400-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillicExt',
      src: 'roboto-v32-cyrillic-ext-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'roboto-v32-cyrillic-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'greekExt',
      src: 'roboto-v32-greek-ext-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'greek',
      src: 'roboto-v32-greek-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'roboto-v32-vietnamese-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'roboto-v32-latin-ext-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'italic',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'roboto-v32-latin-700-italic.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillicExt',
      src: 'roboto-v32-cyrillic-ext-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'cyrillic',
      src: 'roboto-v32-cyrillic-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greekExt',
      src: 'roboto-v32-greek-ext-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'greek',
      src: 'roboto-v32-greek-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'vietnamese',
      src: 'roboto-v32-vietnamese-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latinExt',
      src: 'roboto-v32-latin-ext-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'normal',
      unicodeRange: 'latin',
      src: 'roboto-v32-latin-400.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillicExt',
      src: 'roboto-v32-cyrillic-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'cyrillic',
      src: 'roboto-v32-cyrillic-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greekExt',
      src: 'roboto-v32-greek-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'greek',
      src: 'roboto-v32-greek-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'vietnamese',
      src: 'roboto-v32-vietnamese-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latinExt',
      src: 'roboto-v32-latin-ext-700.woff2',
      format: 'woff2',
    },
    {
      fontStyle: 'normal',
      fontWeight: 'bold',
      unicodeRange: 'latin',
      src: 'roboto-v32-latin-700.woff2',
      format: 'woff2',
    },
  ],
};
